import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from '../../common/Header';
import ContactUsCallouts from './ContactUsCallouts';
import SupportNav from '../SupportNav';
import Breadcrumb from '../../common/Breadcrumb';
import BreadcrumbItem from '../../common/BreadcrumbItem';

class ContactUsLanding extends Component {
	render() {
		return (
			<div className="contact-us">
				<Helmet>
					<title>Contact Us | SentrySafe</title>
					<meta name="description" content="The SentrySafe Customer Care Team is dedicated to providing timely and exceptional service and support to our customers. Contact Us Now." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Support" path="/support" />
					<BreadcrumbItem label="Contact Us" />
				</Breadcrumb>

				<SupportNav />

				<Header
					title="Need Additional Support?"
					description="We are dedicated to providing timely and exceptional service to our customers. Select an option below to get in touch with a support team."
				/>

				<ContactUsCallouts />
			</div>
		);
	}
}

export default ContactUsLanding;


// WEBPACK FOOTER //
// ./src/pages/support/contactUs/ContactUsLanding.js